import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Radio from "./radio";


export default class EventTimeFrame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventTimes: props.data,
    };
  }

  handleOccurrence = (value, index) => {
    this.setState(
      ({ eventTimes }) => ({
        eventTimes: eventTimes.map((a, idx) =>
          idx === index ? { ...a, checked: true } : { ...a, checked: false }
        )
      })
    );

    let timeCopy = { ...this.props.values.time_frame }
    if (value.target.value === "one_off") {
      timeCopy[value.target.value] = true
      timeCopy["recurring"] = false
    } else {
      timeCopy[value.target.value] = true
      timeCopy["one_off"] = false
    }
    this.props.onChange("time_frame", timeCopy)
  };

  handleTime = value => {
    let timeCopy = { ...this.props.values.time_frame }
    timeCopy["start"] = new Date(value.target.value);
    this.props.onChange("time_frame", timeCopy)
  };

  render() {
    return (
      <div>
        <Row>
          <Col>
            <h4 className="ui centered question-header text-center">One-off or recurring event?</h4>
          </Col>
        </Row>
        <Row>
          {
            this.state.eventTimes.map((timeFrame, index) => (
              <Radio
                name="time_frame"
                key={timeFrame.value}
                attendee={timeFrame}
                onChange={(value) => this.handleOccurrence(value, index)}
                {...timeFrame}
              />
            ))
          }
        </Row>
        <Row className="d-flex align-items-center">
          <Col>
            <h4 className="question-header date-text">What is the first day of your event?</h4>
          </Col>
          <Col>
            <input type="date" className="form-control date" name="start"
                   onChange={this.handleTime}/>
          </Col>
        </Row>
      </div>
    )
  }
}
